module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item.is_top == 1 || _vm.item.is_wonderful == 1) ? _c('div', {
    staticClass: "review_icon"
  }, [_vm._v(_vm._s(_vm.item.is_top == 1 ? '置顶' : _vm.item.is_wonderful == 1 ? '精彩' : ''))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32b02e76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topWonder.vue
// module id = 217
// module chunks = 3